<template>
  <div class="w-[420px] operation-wrap">
    <AccountLogin
      v-if="status === 'login'"
      @back="status = 'resetPwd'"
      @success="$emit('next')"
      @accountSelect="onSelectAccount"
    />
    <SelectAccount v-model:open="open" @select="onSelect" />
    <AccountResetPwd v-if="status === 'resetPwd'" @back="status = 'login'" />
    <TasteAccountHint
      v-model:open="tasteAccountListOpen"
      :accounts="tasteAccounts"
    >
      <div class="flex justify-center mt-[16px]">
        <a-button class="w-[368px]" type="primary" @click="switchAccount">
          {{ $t('qie-huan-zhang-hao') }}
        </a-button>
      </div>
    </TasteAccountHint>
  </div>
</template>
<script lang="ts" setup>
import { USER_LEVEL_KEY, type LoginInfo } from '~/api/interface'
import { USER_ADMIN } from '~/constants'
import AccountLogin from '~/features/account/login/base'
import AccountResetPwd from '~/features/account/reset/base.vue'
import SelectAccount from '~/features/account/select/selectModal.vue'
import TasteAccountHint from '~/features/tasteAccountHint/index.vue'

type Status = 'login' | 'resetPwd'

const status = ref<Status>('login')

const emit = defineEmits(['next'])

const open = ref(false)
const tasteAccountListOpen = ref(false)

const tasteAccounts = ref<LoginInfo[]>([])

let accountSelectToNext = true

function onSelectAccount(loginInfos: LoginInfo[]) {
  accountSelectToNext = true
  // 如果有体验版账号
  tasteAccounts.value = loginInfos.filter((item) => {
    return (
      Number(item.rights_type) === USER_LEVEL_KEY.TEAM_TASTE &&
      Number(item.permission) !== USER_ADMIN.NORMAL
    )
  })

  if (tasteAccounts.value.length > 0) {
    tasteAccountListOpen.value = true
    return
  }

  open.value = true
}

// 账号选择后，进入下一步

const router = useRouter()
const homeRoute = useHomeRoute()

function onSelect() {
  if (accountSelectToNext) {
    emit('next')
    open.value = false
  } else {
    router.push(homeRoute)
  }
}

function switchAccount() {
  accountSelectToNext = false
  tasteAccountListOpen.value = false
  open.value = true
}
</script>
<style lang="scss" scoped>
.operation-wrap {
  position: relative;
  padding: 70px 90px 40px;
  width: 600px;
  background: var(--login-operation-bg);
  border-radius: 20px;
  border: 1px solid var(--back-3);
}
</style>
